/**
 * Recently-viewed products — pure-localStorage, no API calls.
 *
 * Looks for any element with `data-fragrenza-recents="pdp"` or `="cart"`.
 * - On a PDP container, the current product is read from data-attrs and
 *   pushed into `localStorage[fragrenza_recents]` as a {handle,title,image,price} entry.
 * - Then up to N cards are rendered inside the container (current product
 *   filtered out on PDP).
 *
 * Re-initializes when new containers appear in the DOM (e.g. cart drawer
 * refetches its HTML via Shopify's Sections API after add-to-cart).
 */
(function () {
  var STORAGE_KEY = 'fragrenza_recents';
  var MAX_STORED = 12;
  var LIMITS = { pdp: 6, cart: 4 };

  function loadRecents() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function saveRecents(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_STORED)));
    } catch (e) {}
  }

  function trackPDP(c) {
    var handle = c.dataset.handle;
    if (!handle) return;
    var entry = {
      handle: handle,
      title: c.dataset.title || '',
      image: c.dataset.image || '',
      price: c.dataset.price || ''
    };
    var list = loadRecents().filter(function (p) { return p && p.handle !== handle; });
    list.unshift(entry);
    saveRecents(list);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[ch];
    });
  }

  function renderCard(p) {
    var img = p.image
      ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="200" height="200">'
      : '';
    return (
      '<a class="fr-recents__card" href="/products/' + encodeURIComponent(p.handle) + '">' +
        '<div class="fr-recents__img-wrap">' + img + '</div>' +
        '<div class="fr-recents__info">' +
          '<div class="fr-recents__title">' + escapeHtml(p.title) + '</div>' +
          '<div class="fr-recents__price">' + escapeHtml(p.price) + '</div>' +
        '</div>' +
      '</a>'
    );
  }

  function render(c) {
    var context = c.dataset.fragrenzaRecents;
    var limit = LIMITS[context] || 6;
    var recents = loadRecents();
    if (context === 'pdp' && c.dataset.handle) {
      recents = recents.filter(function (p) { return p && p.handle !== c.dataset.handle; });
    }
    recents = recents.slice(0, limit);
    if (recents.length === 0) {
      c.style.display = 'none';
      c.removeAttribute('data-fragrenza-rendered');
      return;
    }
    c.style.display = '';
    c.innerHTML =
      '<div class="fr-recents__inner">' +
        '<h3 class="fr-recents__heading">Recently Viewed</h3>' +
        '<div class="fr-recents__row">' + recents.map(renderCard).join('') + '</div>' +
      '</div>';
    c.setAttribute('data-fragrenza-rendered', '1');
  }

  function init() {
    var containers = document.querySelectorAll('[data-fragrenza-recents]');
    for (var i = 0; i < containers.length; i++) {
      var c = containers[i];
      if (c.dataset.fragrenzaInit) {
        // Already initialized this DOM node — but localStorage may have
        // changed (e.g. a navigation in the same tab via cart drawer).
        // Cheap to re-render; no tracking on already-tracked containers.
        render(c);
        continue;
      }
      c.dataset.fragrenzaInit = '1';
      if (c.dataset.fragrenzaRecents === 'pdp' && c.dataset.handle) {
        trackPDP(c);
      }
      render(c);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Cart drawer refetches its HTML on every cart update — watch for any
  // newly-inserted recently-viewed container and render it.
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (
            (n.matches && n.matches('[data-fragrenza-recents]')) ||
            (n.querySelector && n.querySelector('[data-fragrenza-recents]'))
          ) {
            init();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
